export const AUDIENCE_KINDS = ["CLIENT", "PARTNER", "EMPLOYEE"] as const;

export type AudienceKindName = (typeof AUDIENCE_KINDS)[number];

export function parseAudienceKind(raw: string): AudienceKindName | null {
  return AUDIENCE_KINDS.find((item) => item === raw.trim()) ?? null;
}
